<ion-content>
  <div class="iconList">
    @for (icon of availableIcons; track icon) {
      <doka-icon
        (click)="selectIcon(icon)"
        [ngClass]="{ selectedIcon: selectedIcon === icon }"
        size="4xl"
        [name]="icon"
      ></doka-icon>
    }
  </div>
</ion-content>
